import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import './PrivacyPolicy.scss';

function PrivacyPolicy() {
  return (
    <>
      <Helmet>
        <title>Privacy Policy | Valendris</title>
        <meta name="description" content="Privacy policy for Valendris LLC. Learn how I handle your personal information." />
      </Helmet>
      <section className="privacy-policy">
      <div className="privacy-policy-container container">
        <h1 className="privacy-policy-title">Privacy Policy</h1>
        <p className="privacy-policy-updated">Last updated: January 2026</p>

        <div className="privacy-policy-content">
          <div className="privacy-policy-section">
            <h2 className="privacy-policy-section-title">Information We Collect</h2>
            <p className="privacy-policy-text">
              When you contact us through our website, we collect the information you provide, including your name, email address, company name (if provided), and message content. We use this information solely to respond to your inquiry.
            </p>
          </div>

          <div className="privacy-policy-section">
            <h2 className="privacy-policy-section-title">How We Use Your Information</h2>
            <p className="privacy-policy-text">
              We use the information you provide to:
            </p>
            <ul className="privacy-policy-list">
              <li>Respond to your inquiries and requests</li>
              <li>Communicate with you about potential projects</li>
              <li>Improve our services and website</li>
            </ul>
          </div>

          <div className="privacy-policy-section">
            <h2 className="privacy-policy-section-title">Information Sharing</h2>
            <p className="privacy-policy-text">
              We do not sell, trade, or otherwise transfer your personal information to third parties. Your information may be shared only when required by law or to protect our rights.
            </p>
          </div>

          <div className="privacy-policy-section">
            <h2 className="privacy-policy-section-title">Data Security</h2>
            <p className="privacy-policy-text">
              We implement appropriate security measures to protect your personal information. However, no method of transmission over the internet is 100% secure, and we cannot guarantee absolute security.
            </p>
          </div>

          <div className="privacy-policy-section">
            <h2 className="privacy-policy-section-title">Cookies</h2>
            <p className="privacy-policy-text">
              Our website may use cookies to enhance your browsing experience. You can choose to disable cookies through your browser settings.
            </p>
          </div>

          <div className="privacy-policy-section">
            <h2 className="privacy-policy-section-title">Contact Us</h2>
            <p className="privacy-policy-text">
              If you have questions about this Privacy Policy, please{' '}
              <Link to="/contact" className="privacy-policy-link">
                contact us
              </Link>.
            </p>
          </div>
        </div>
      </div>
    </section>
    </>
  );
}

export default PrivacyPolicy;
